<template>
  <!-- PRECISA VERIFICA A INDEPENDENCIA DO V-MODEL COM O MAPPED GETTER PARA LIMPAR/REINICIAR A MODAL CORREATAMENTE -->

  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:8px">
        <v-card-title class="pa-0 ma-0">
          <v-toolbar
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            color="primary"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left color="white">fa-tshirt</v-icon>Escalar jogadores
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog=false, clearShirts()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="teamsTabs" grow>
            <v-tab v-for="(title, index) in [homeTeam, awayTeam]" :key="index">{{title.team_name}}</v-tab>
            <v-tabs-items v-model="teamsTabs">
              <v-tab-item v-for="(team, index) in [homeTeam, awayTeam]" :key="index">
                <v-card>
                  <v-data-table :headers="headers" :items="team.squads" hide-actions>
                    <template slot="items" slot-scope="props">
                      <!-- <td class="text-xs-center"><v-checkbox v-model="props.selected" return-object primary hide-details></v-checkbox></td> -->
                      <td class="text-xs-center">{{ props.item.player_name }}</td>
                      <td class="text-xs-center">
                        <v-layout row wrap justify-center>
                          <v-flex xs12 text-xs-center>
                            <v-text-field
                              type="tel"
                              single-line
                              prepend-icon="fa-tshirt"
                              mask="##"
                              v-model="props.item.shirt"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" round @click="submitSquadNumbers()">
            <v-icon left>save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="dialog=true" color="primary">
          <v-icon small left dark color="white">fa-tshirt</v-icon>Escalar Jogadores
        </v-btn>
      </v-flex>
    </v-layout>
    <card-loading v-if="loading" :loadText="loadText"></card-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loadText: "",
      dialog: false,
      teamsTabs: 0,
      headers: [
        {
          text: "Atleta",
          align: "center",
          value: "name",
          sortable: false,
          width: "2%"
        },
        {
          text: "Núm.",
          align: "center",
          value: "number",
          sortable: false,
          width: "1%"
        }
      ]
    };
  },
  methods: {
    submitSquadNumbers() {
      var squad_numbers_attributes = []; // tentando corrigir TOO MANY REQUEST fazendo aninhamento por match
      this.homeTeam.squads.forEach(element => {
        if (element.shirt) {
          var sn = {};
          sn.id = element.squad_number_id;
          sn.number = element.shirt;
          sn.squad_id = element.id;
          sn.match_id = this.oneMatch.data.attributes.id;
          squad_numbers_attributes.push(sn);
        }
      });
      this.awayTeam.squads.forEach(element => {
        if (element.shirt) {
          var sn = {};
          sn.id = element.squad_number_id;
          sn.number = element.shirt;
          sn.squad_id = element.id;
          sn.match_id = this.oneMatch.data.attributes.id;
          squad_numbers_attributes.push(sn);
        }
      });
      console.log(squad_numbers_attributes);
      this.$http
        .put(`/api/v1/matches/${this.oneMatch.data.attributes.id}`, {
          match: {
            squad_numbers_attributes
          }
        })
        .then(() => (squad_numbers_attributes = []))
        .catch(error => {
          console.log({ error });
        });

      this.loading = true;
      this.loadText = "escalando...";
      setTimeout(() => {
        this.dialog = false;
        this.loading = false;
        this.loadText = "";
        this.showOneMatch(this.oneMatch.data.attributes.id, "0");
      }, 1000);
    },
    clearShirts() {
      // this.homeTeam.squads.forEach(element => {
      //   element.shirt = null;
      // });
      // this.awayTeam.squads.forEach(element => {
      //   element.shirt = null;
      // });
    },
    ...mapActions({
      showOneMatch: "Match/show"
    })
  },
  computed: {
    homeTeam() {
      return this.homeTeamState;
    },
    awayTeam() {
      return this.awayTeamState;
    },
    ...mapGetters({
      homeTeamState: "Match/teamA",
      awayTeamState: "Match/teamB"
    }),
    ...mapState({
      oneMatch: state => state.Match.oneMatch
    })
  }
};
</script>

<style scoped>
</style>